import { useTranslation } from "react-i18next";
import { Quote } from "lucide-react";
import { SEO } from "@/components/SEO";
import { RevealText } from "@/components/shared/RevealText";
import { StaggerGroup, StaggerItem } from "@/components/shared/SectionReveal";

export default function Testimonials() {
  const { t } = useTranslation();
  const items = t("testimonials.items", { returnObjects: true });

  return (
    <div data-testid="testimonials-page">
      <SEO title={`${t("testimonials.hero_title")} — Fastority`} description={t("testimonials.hero_subtitle")} path="testimonials" />

      <section className="bg-deepblue text-white py-24 sm:py-28 grain-overlay relative overflow-hidden">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 relative">
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter">
            <RevealText lines={[t("testimonials.hero_title")]} />
          </h1>
          <p className="mt-6 text-lg text-white/70">{t("testimonials.hero_subtitle")}</p>
        </div>
      </section>

      <section className="py-20 sm:py-24 bg-offwhite">
        <div className="max-w-6xl mx-auto px-5 sm:px-8">
          <StaggerGroup className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((it, i) => (
              <StaggerItem key={it.name}>
                <div data-testid={`testimonial-card-${i}`} className="bg-white rounded-3xl p-7 h-full border border-gray-100 shadow-[0_8px_30px_rgba(30,58,138,0.06)]">
                  <Quote className="text-coral mb-4" size={26} />
                  <p className="text-slate-700 leading-relaxed mb-6">&ldquo;{it.quote}&rdquo;</p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-deepblue text-white flex items-center justify-center font-heading font-bold text-sm">
                      {it.name.charAt(0)}
                    </div>
                    <div>
                      <p className="font-semibold text-slate900 text-sm">{it.name}</p>
                      <p className="text-xs text-slate-500">{it.role}</p>
                    </div>
                  </div>
                </div>
              </StaggerItem>
            ))}
          </StaggerGroup>
        </div>
      </section>
    </div>
  );
}
